import React from 'react';
import { Button } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';
const pulseGlow = keyframes`
  0% { box-shadow: 0 0 0 0 rgba(255, 184, 0, 0.8); }
  70% { box-shadow: 0 0 35px 18px rgba(255, 184, 0, 0); }
  100% { box-shadow: 0 0 0 0 rgba(255, 184, 0, 0); }
`;
interface CTAButtonProps {
  text: string;
  onClick?: () => void;
  href?: string;
}
export function CTAButton({
  text,
  onClick,
  href
}: CTAButtonProps) {
  return <Button as={href ? 'a' : 'button'} href={href} onClick={onClick} size="lg" w={{
    base: '100%',
    md: 'auto'
  }} px={{
    base: 8,
    md: 16
  }} py={8} bg="linear-gradient(135deg, #ffb800 0%, #ffd700 100%)" color="#0f172a" fontSize={{
    base: 'md',
    md: 'xl'
  }} fontWeight="extrabold" textTransform="uppercase" letterSpacing="wider" borderRadius="md" border="2px solid" borderColor="#fff" boxShadow="0 0 25px rgba(255, 184, 0, 0.6), 0 0 15px rgba(255, 215, 0, 0.4)" _hover={{
    bg: 'linear-gradient(135deg, #ffd700 0%, #ffea00 100%)',
    color: '#000',
    transform: 'scale(1.05)',
    animation: `${pulseGlow} 1.5s infinite`,
    boxShadow: '0 0 40px rgba(255, 184, 0, 0.9), 0 0 20px rgba(255, 215, 0, 0.7)',
    textDecoration: 'none'
  }} _active={{
    bg: 'linear-gradient(135deg, #e6a600 0%, #ffb800 100%)',
    transform: 'scale(0.98)'
  }} transition="all 0.3s ease" whiteSpace="normal" h="auto" lineHeight="1.4" textAlign="center" data-id="element-27">
      {text}
    </Button>;
}